module.exports = __webpack_public_path__ + "assets/photos/memories/frame-2-mobile--9cbdc267b24f9bb4d8c7168bd5209fe9.jpg";